import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, useTheme } from '@mui/material'
import { isEmpty } from 'lodash'
import { LabraToolTipV2 } from '@labrav/react-components'

import { textOverFlowSpace, useColumnReadMoreStyles } from '@labrav/common'

export const TruncateWithLink = ({
  text,
  link,
}: {
  text: string
  link?: string
}) => {
  const theme = useTheme()
  const { classes } = useColumnReadMoreStyles()
  const { truncateDescription, descriptionRef } = textOverFlowSpace({
    customCharForRemoveFromMax: 12,
    description: text,
  })

  const isTruncated = truncateDescription(text) !== text
  return (
    <div ref={descriptionRef} className={classes.linkWrapper}>
      <LabraToolTipV2
        tooltipPlacement="top"
        description={isTruncated ? text : ''}
      >
        {truncateDescription(text)}
      </LabraToolTipV2>
      {isEmpty(link) ? null : (
        <>
          {' '}
          <Link
            rel="noopener"
            target="_blank"
            href={link}
            data-testid="cell-link"
            component={'a'}
            style={{ cursor: 'pointer' }}
          >
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              style={{
                width: '14px',
                height: '15px',
                color: theme.palette.primary.main,
              }}
            />
          </Link>
        </>
      )}
    </div>
  )
}
